import React from 'react';
import deleteimage from '../image/delete.png';

class FestivalItem extends React.Component {

    constructor(props) {
      super(props);
    }


    fn_updateItemInfo = (item) =>{
      this.props.fn_updateitem(this.props.itemIndex,item);
    }

    fn_hanleno1ItemCd = (e) =>{
      let updateItem=[];
      let no2ItemArr = [];
      switch (e.target.value) {
        case "0001":
          no2ItemArr = no2ItemArr01;
        break;

        case "0002":
          no2ItemArr = no2ItemArr02;
        break;

        case "0003":
          no2ItemArr = no2ItemArr03;

        break;

        case "0004":
          no2ItemArr = no2ItemArr04;
        break;
        default:
      }
      let no2ItemCd = no2ItemArr[0].value;
      updateItem = {no1ItemCd: e.target.value,no2ItemCd:no2ItemCd,co2Emissions:0};
      this.fn_updateItemInfo(updateItem);
    }

    fn_handleno2ItemCd = (e) =>{
      let updateItem=[];
      updateItem = {no1ItemCd: this.props.no1ItemCd,no2ItemCd:e.target.value,co2Emissions:0};
      console.log(e.target.selectedIndex+ "e.target.selectedIndex");
      this.fn_updateItemInfo(updateItem);
    }

    fn_deleteItem = (e) =>{
      this.props.fn_deleteitem(this.props.itemIndex);
    }
    fn_handleCount = (e) => {
      console.log("handlecount");
      this.props.fn_calCo2Emission(this.props.itemIndex,e.target.value);
    }

  render() {

    let no1ItemList = no1ItemArr.length > 0
      && no1ItemArr.map((item, i) => {
      return (
        <option key={i} value={item.value}>{item.text}</option>
      )
    }, this);
    const no1ItemCd = this.props.no1ItemCd;
    let no2ItemArr =[];
    switch (no1ItemCd) {
      case "0001":
        no2ItemArr = no2ItemArr01;
      break;
      case "0002":
        no2ItemArr = no2ItemArr02;
      break;
      case "0003":
        no2ItemArr = no2ItemArr03;
      break;
      case "0004":
        no2ItemArr = no2ItemArr04;
      break;

      default:
    }
    let no2ItemList = no2ItemArr.length > 0
      && no2ItemArr.map((item, i) => {
      return (
        <option key={i} value={item.value}>{item.text}</option>
      )
    }, this);
    let selectedIndex = 0;
    for(let i in no2ItemArr){
      if(no2ItemArr[i].value == this.props.no2ItemCd)
      {
        selectedIndex = i;
        break;
      }
    }
    let unitText = JSON.parse(JSON.stringify(no2ItemArr[selectedIndex],["unit"])).unit;

    let co2Emissions = parseFloat(this.props.co2Emissions).toFixed(4);
    return (
      <div style={itemDivStyle}>
      <div style={itemInputDivStyle}>
        <div styl={selectDivStyle}>
        <select style={combostlye}  onChange={this.fn_hanleno1ItemCd}>
          {no1ItemList}
        </select>
        <select style={combostlye} onChange={this.fn_handleno2ItemCd}>
          {no2ItemList}
        </select>
        </div>
        <div style={unitDivStyle}>
          <input id="inputCount" style={countInputstyle} onChange={this.fn_handleCount} type="number" name="count"/>
          단위 : {unitText}
        </div>
          <button style={imageButton} onClick={this.fn_deleteItem}>
            <img padding="30px" width="30px" src={deleteimage}/>
          </button>
        </div>

        <div style={resultDiv}>
          CO₂ 배출량 : {co2Emissions}
        </div>
      </div>
    );
  }
}

const resultDiv={
  fontSize:"14px",
  fontWeight:"bold"
}

const imageButton= {
  background:"white",
  border:"0px"
};

const no1ItemArr=[{ text: '일회용품 사용량', value: '0001' },
                  { text: '전력 사용량', value: '0002' },
                  { text: '폐기물배출', value: '0003' },
                  { text: '장비 전력 배출량', value: '0004' }];


const no2ItemArr01=[{ text: '종이', value: '0011', unit:"장" },
                  { text: '테이크아웃 컵', value: '0012', unit:"개" },
                  { text: '종이컵', value: '0013', unit:"개" },
                  { text: '플라스틱 무게', value: '0014' ,unit:"KG"},
                  ];

const no2ItemArr02=[{ text: '사무실운영', value: '0021' , unit:"1인 1일 전력사용량 x 근무시간"},
                    { text: '야외행사', value: '0022',unit:"발전차 전력 사용량 X 사용시간" },
                    { text: '실내행사', value: '0023' ,unit:"전력사용량"},
                    { text: '숙박시설 이용', value: '0024',unit:"숙박일 X 1인 전력 사용량" },
                    { text: '인쇄 홍보물', value: '0025' ,unit:"장"},
                    ];

const no2ItemArr03=[{ text: '폐기물 배출량', value: '0031' ,unit:"폐기물 무게(KG)"},
                    ];

const no2ItemArr04=[{ text: '컴퓨터 사용량', value: '0041' ,unit:"용량(W) x 사용시간(H)"},
                    { text: '프린터 사용량', value: '0042' ,unit:"용량(W) x 사용시간(H)"},
                    { text: '앰프 사용량', value: '0043' ,unit:"용량(W) x 사용시간(H)"},
                    { text: '빔프로젝터 사용량', value: '0044' ,unit:"용량(W) x 사용시간(H)"},
                    { text: '발전차 사용량', value: '0045' ,unit:"용량(W) x 사용시간(H)"},
                   ];

const itemDivStyle = {
  height: "150px",
  borderBottom: "1px solid",
}

const itemInputDivStyle = {
  height: "100px",
  justifyContent: "center",
  alignItems: "center",
  display:"flex",
  flexDirection: "row",
  paddingLeft:"10%",
  paddingRight:"10%"
}
const selectDivStyle = {
  display:"flex",
  flexDirection: "row",
}
FestivalItem.defaultProps = {
      itemIndex: "0",
      no1ItemCd: "0001",
      no2ItemCd: "0011",
      co2Emissions: "0"
};
const selectItemStyle ={


}
const combostlye = {
  width:"180px",
  height: "50px",
  color: "black",
  fontSize : "15px",
  marginLeft: "20px"
}
const unitDivStyle = {
  width :"450px",
  marginRight:"20px",
  float:"left",
  display:"flex",
  justifyContent:"flex-start",
  alignItems:"center",
  fontSize:"12px"
}
const countInputstyle ={
  height :"40px",
  width:"150px",
  marginLeft:"20px",
  marginRight:"20px",
  float:"right"
}


export default FestivalItem;
